import { gql } from '@apollo/client';

export default gql`
  mutation UnassignOfflineTask($input: UnassignOfflineTaskInput!) {
    unassignOfflineTask(input: $input) {
      id
      matchId
    }
  }
`;
